import * as React from 'react'

import Svg, { Path, SvgProps } from 'react-native-svg'

const MinusSvg = ({ color, ...props }: SvgProps) => (
    <Svg
        width={9}
        height={2}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color={color || '#000'}
        {...props}
    >
        <Path
            d="M.85 1h7.08"
            stroke="currentColor"
            strokeWidth={0.885}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
)

export default MinusSvg
